import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";
import { setFlexF1 } from "theme/setter/setFlexValues/setFlexF1";

export const SGroupTableContainer = styled.div`
  ${setFlexDFFDC};
  ${setFlexF1};
`;
